import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import AuthLayout from '../components/auth/AuthLayout';
import AuthResult from '../components/auth/AuthResult';
import Button from '../components/ui/Button';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Token de verificação não fornecido.');
        return;
      }

      try {
        await api.post('/users/verify-email', { token });
        setStatus('success');
        setMessage('Email verificado com sucesso! Você será redirecionado para o login.');

        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (error: any) {
        setStatus('error');
        const errorMessage = error.response?.data?.error ||
                            error.response?.data?.message ||
                            'Erro ao verificar email. O token pode estar expirado ou inválido.';
        setMessage(errorMessage);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <AuthLayout>
      {status === 'loading' && (
        <AuthResult tone="loading" title="Verificando seu email...">
          <p>Aguarde enquanto processamos sua verificação.</p>
        </AuthResult>
      )}

      {status === 'success' && (
        <AuthResult tone="success" title="Email Verificado!">
          <p>Sua conta está agora <strong className="text-success-text">ATIVA</strong>!</p>
          <p>Você já pode fazer login no sistema.</p>
          <p className="text-xs text-fg-subtle">Redirecionando para o login...</p>
        </AuthResult>
      )}

      {status === 'error' && (
        <AuthResult
          tone="danger"
          title="Erro na Verificação"
          actions={(
            <>
              <Button fullWidth onClick={() => navigate('/login')}>Ir para Login</Button>
              <Button fullWidth variant="secondary" onClick={() => navigate('/register')}>Registrar Novamente</Button>
            </>
          )}
        >
          <p>{message}</p>
        </AuthResult>
      )}
    </AuthLayout>
  );
};

export default VerifyEmailPage;
